import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { CircularProgress, IconButton } from "@mui/material";
import { Menu, MenuItem } from "@szhsin/react-menu";
import { MdKeyboardArrowDown } from "react-icons/md";
import SimpleDialogDemo from "src/Modules/Reusuablecomponents/CustomizedDialogs";
import ReusuableDeleteDialogmodal from "src/Modules/Reusuablecomponents/ReusuableDeleteModal";
import ReusuableReportDialogmodal from "src/Modules/Reusuablecomponents/ReusuableReportDialogmodal";
import PostMessageValidation from "src/Modules/Reusuablecomponents/PostMessageValidation";
import ReusuableSendaMailModal from "src/Modules/Reusuablecomponents/ReusuableSendaMailModal";
import AvatarBadge from "src/Components/AvatarBadge";
import ChildSay from "src/pages/HomePage/components/ChildSay";
import location from "src/Assets/images/userlocationtag.png";
import saysoutlineimage from "src/Assets/images/noofsays.svg";
import follow from "src/Assets/images/follow.svg";
import unfollow from "src/Assets/images/unfollow.svg";
import like from "src/Assets/images/like.svg";
import unlike from "src/Assets/images/unlike.svg";
import NoDataFound from "src/Assets/images/data-not-found.svg";
import dotImage from "src/Assets/images/dot.png";
import dropdownImage from "src/Assets/images/downarrow.svg";
import ConfirmationDialog from "src/Components/ConfirmationDialog";
// import smallike from "src/Assets/images/smallike.png";
import edit from "src/Assets/images/edit.svg";
import share from "src/Assets/images/share.svg";
import rating from "src/Assets/images/rating.png";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import poststyles from "src/Assets/css/home/post.module.css";
import API from "src/network";
import useStyles from "./styles";
import _ from "lodash";
import TextWithUrlsAndHashTags from "src/Components/TextWithUrlsAndHashTags";
import MapDialog from "../../../pages/HomePage/components/LocationAddress";
import { ProfileHoverCard } from "src/pages/HomePage/components/ProfileHoverCard";
import replyIcon from "src/Assets/images/message new icon.png";
import answerIcon from "src/Assets/images/answerIcon.png";
import PostAttachmentViewer from "src/Utils/PostAttachmentViewer";
import { PiDotsThreeBold } from "react-icons/pi";
import Tooltip from "@mui/material/Tooltip";
import ReusuableTagActionModal from "src/Utils/ReusuableTagActionModal";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";

const Feed = ({
  data,
  handleSayClick,
  id,
  childSaysData,
  handleFollowunfollow,
  childSayLoading,
  feedLoading,
  isActionDisabled,
  fetchVoteUpStatus = () => {},
  fetchFeedData = () => {},
  deleteMessage = () => {},
  refreshFeedData = () => {},
  postChildSayData = () => {},
  fetchChildSaysData = () => {},
  flow,
  filterType,
  feedPageNumber = 1,
  onHashTagClick,
  onActionSuccess
}) => {
  const imageServerURL = process.env.REACT_APP_SKOPIC_IMAGE_OTHER;
  const {
    feedContainer,
    feedMessage,
    avatarDetails,
    avatar,
    locationandtime,
    followerandcount,
    askcount,
    saycount,
    updatecount,
    tagcount,
    followcount,
    saysandfollow,
    noOfsays,
    noOffollows,
    followtext,
    likeunlike,
    nodata,
    profileHoverImageCount,
    profilehovername,
    profilecount,
    profilehovercontent,
    feeddropdown,
    answerIconImg,
    replyIconImg,
  } = useStyles();
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const [isMoreLoading, setIsMoreLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [editPostId, setEditPostId] = useState(null);
  const [feedList, setFeedList] = useState([]);
  const [currentPage, setCurrentPage] = useState(feedPageNumber);
  const [showUnfollowAlert, setShowUnfollowAlert] = useState(null);
  const loader = useRef(null);
  const listRef = useRef(null);
  const [openMap, setOpenMap] = useState(false);
  const [clickedLocation, setClickedLocation] = useState({
    locAddress: "",
    latitude: "",
    longitude: "",
  });
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [isAttacmentDeleted, setIsAttacmentDeleted] = useState(null);

  const options = {
    root: null,
    rootMargin: "20px",
    threshold: 0,
  };

  useEffect(() => {
    setCurrentPage(feedPageNumber);
    setHasMore(true);
  }, [feedPageNumber]);

  useEffect(() => {
    setFeedList(data);
  }, [data]);

  const handleClickOpen = (address, lat, lng) => {
    setOpenMap(true);
    setClickedLocation({
      locAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleCloseMap = () => {
    setOpenMap(false);
  };

  const handleScroll = useCallback(() => {
    if (!hasMore || isMoreLoading) return; // indicates that there will be no more data
    const { scrollTop, clientHeight, scrollHeight } = listRef.current;

    if (scrollTop + clientHeight + 100 >= scrollHeight) {
      setIsMoreLoading(true);
      setCurrentPage((prevPage) => prevPage + 1);
    }
  }, [hasMore, isMoreLoading]);

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) observer.observe(loader.current);

    return () => {
      if (loader.current) observer.unobserve(loader.current);
    };
  }, [loader, options]);

  useEffect(() => {
    (async () => {
      setIsMoreLoading(true);
      const pageNumber = (currentPage - 1) * 10;
      try {
        const response = await API.fetchFeedData(filterType, pageNumber);
        const { feed } = response.data;
        if (feed && Array.isArray(feed) && feed.length) {
          setFeedList((prevFeedList) =>
            _.uniqBy([...prevFeedList, ...response.data.feed], "id"),
          );
        } else {
          setHasMore(false); // No more data available
        }
      } catch (e) {
        console.error(e);
      } finally {
        setIsMoreLoading(false);
      }
    })();
  }, [currentPage]);

  const handleObserver = useCallback(
    (entries) => {
      const target = entries[0];
      // if (props.data.totalfeedsizeincommunity !== props.data.breadCountLength) {
      //   if (target.isIntersecting) {
      //     // dispatch(feedactions.fetchFeedData(`?startlimit=${props.data.breadCountLength}${props.filtertype}`))
      //     // if(props.listdata)
      //     // {
      //     //     setFeed(oldFeed=>[...oldFeed,this.props.listdata])
      //     //     console.log(isFeed)
      //     // }
      //   }
      // }
    },
    [data],
  );

  const onEditSelection = (id) => {
    setEditPostId(id);
  };

  const onCloseEdit = (id) => {
    setEditPostId(null);
  };

  const onLikeUnlikeSelection = (id, cache) => {
    if (isActionDisabled) return;
    likeUnlike(id);
    fetchVoteUpStatus(id, cache);
  };

  const likeUnlike = (id) => {
    const newData = [...feedList];
    const modifiedData = newData.find((x) => x.id === id);
    modifiedData.UserLikeStatus = "InActive";
    modifiedData.voteUp = modifiedData.voteUp - 1 + 2;
    setFeedList(newData);
  };

  //to perform this follow unfollow actions
  const onFollowUnfollow = (id, followstatus) => {
    if (followstatus === "isFollow=0") {
      setShowUnfollowAlert({
        id,
        followstatus,
      });
    } else {
      followunfollowCallback(id, followstatus);
    }
  };

  const followunfollowCallback = (id, followstatus) => {
    if (isActionDisabled) return;
    updateList(id, followstatus);
    handleFollowunfollow(id, followstatus);
  };

  const updateList = (id, followStatus) => {
    const newData = [...feedList];
    const modifiedData = newData.find((x) => x.id === id);
    modifiedData.followStatus = followStatus.includes("0") ? "N" : "Y";
    modifiedData.followCount = followStatus.includes("0")
      ? modifiedData.followCount - 1
      : modifiedData.followCount - 1 + 2;
    setFeedList(newData);
  };

  const updateFeedListPostMessage = (id, message, locationName, attachment) => {
    const tempUrl =
      attachment instanceof File ? URL.createObjectURL(attachment) : null;
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)[^\s]*)/gi;
    const extractedUrls = message ? (message.match(urlRegex) || []) : [];

    const newData = [...feedList].map((eachItem) => {
      if (eachItem?.id === id) {
        return {
          ...eachItem,
          Message: message,
          msg: message,
          url: extractedUrls.length > 0 ? extractedUrls : eachItem?.url,
          locName: locationName,
          docName: attachment?.name || eachItem.docName || "",
          docLocation: tempUrl || eachItem.docLocation || "",
          docTagged: attachment ? 1 : eachItem.docTagged,
          updated_time: "1m",
          edited: 1,
        };
      }
      return { ...eachItem };
    });
    setFeedList(newData);
    onCloseEdit();
  };

  const handleDeleteAttachementDoc = async (id) => {
    try {
      const response = await API.deleteAttachment(id);

      if (response?.data?.status === "success") {
        alert("Attachment deleted successfully!");

        // Update UI immediately without mutating state
        setFeedList((prevData) =>
          prevData.map((item) =>
            item.id === id
              ? { ...item, docName: null, docLocation: null, docTagged: 0 }
              : item,
          ),
        );
        setIsAttacmentDeleted(response?.data?.status);
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete attachment.");
    } finally {
      setActiveTooltip(null);
    }
  };

  // const showMsg = (type) => {
  //   console.log("showMsg invoked default feed", type);
  //   if (type === "ask") {
  //     return "No Community ASKs available at this time";
  //   } else if (type === "say") {
  //     return "No Community SAYs available at this time";
  //   } else if (type === "update") {
  //     return "No Community UPDATEs available at this time";
  //   } else if (type === "hashtag") {
  //     return "No Community Hashtags available at this time";
  //   } else {
  //     return "No Community data available at this time";
  //   }
  // };

  const showMsg = (type) => {
    console.log("showMsg invoked default feed", type);
    if (type === "OpenASK") {
      return "No Community ASKs available at this time";
    } else if (type === "OpenSAY") {
      return "No Community SAYs available at this time";
    } else if (type === "impupdate") {
      return "No Community UPDATEs available at this time";
    } else if (type === "hashTAG") {
      return "No Community Hashtags available at this time";
    } else {
      return "No Community data available at this time";
    }
  };

  if (feedLoading) {
    return (
      <div className={poststyles.loaderContainer}>
        <CircularProgress
          // size={25}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "100px",
          }}
        />
      </div>
    );
  }

  return (
    <React.Fragment>
      <div
        id="feedScroll"
        className={poststyles.allFeedMainContainer}
        ref={listRef}
        // onScroll={isActionDisabled ? null : handleScroll}
        onScroll={handleScroll}
        style={{ scrollbarWidth: "none" }}
      >
        {feedList?.length > 0 ? (
          feedList?.map((item, index) => {
            return (
              <div className={feedContainer} key={index}>
                <div
                  className={feedstyles.nameAndAvatarWrapper}
                  style={{ position: "relative" }}
                >
                  <div className={feedstyles.avatarDetailsContainer}>
                    <div className={feedstyles.avatarContainer}>
                      <AvatarBadge
                        src={`${imageServerURL}${item?.mainuserdata?.uimage}`}
                        alt={item?.mainuserdata?.displayName}
                        isPrimaryModerator={
                          item?.isPM == 1 || item?.mainuserdata?.isPM == 1
                        }
                        isModerator={
                          (item?.isModerator == 1 ||
                            item?.mainuserdata?.isModerator == 1) &&
                          !(item?.isPM == 1 || item?.mainuserdata?.isPM == 1)
                        }
                      />
                      <ProfileHoverCard
                        result={item}
                        flow={flow}
                        isActionDisabled={isActionDisabled}
                        onActionSuccess={onActionSuccess}
                      />
                    </div>
                    <div style={{ paddingLeft: 5 }}>
                      {/* <span className={feedstyles.profilename}>
                        {item?.mainuserdata?.displayName}
                      </span> */}
                      <span className={feedstyles.profilename}>
                        {item?.mainuserdata?.displayName}
                        {(item?.mainuserdata?.isImpactableMember === "yes" ||
                          item?.isImpactableMember === "yes") && (
                          <img
                            src={alreadyImpactfulMemberImg}
                            alt="Impactful Member"
                            title="Impactful Member"
                            style={{
                              width: "18px",
                              height: "18px",
                              objectFit: "contain",
                              flexShrink: 0,
                              marginLeft: "5px",
                            }}
                          />
                        )}
                      </span>
                      {item?.locName ? (
                        <div className={locationandtime}>
                          <span>{item?.Message_Time}</span>{" "}
                          {item.edited === 1 && (
                            <span> (edited {item.updated_time})</span>
                          )}
                          <img
                            src={dotImage}
                            alt="dot"
                            style={{ marginRight: "5px", marginLeft: "3px" }}
                          />
                          <span
                            onClick={() => {
                              if (!isActionDisabled) {
                                handleClickOpen(
                                  item?.locName,
                                  item?.msgLat,
                                  item?.msgLng,
                                );
                              }
                            }}
                            style={{
                              cursor: isActionDisabled ? "default" : "pointer",
                              pointerEvents: isActionDisabled ? "none" : "auto",
                            }}
                          >
                            <img
                              src={location}
                              alt="location"
                              style={{ marginRight: "3px" }}
                            />
                            {item?.locName}
                          </span>
                        </div>
                      ) : (
                        <div className={locationandtime}>
                          <span>{item?.Message_Time}</span>{" "}
                          {item.edited === 1 && (
                            <span> (edited {item.updated_time})</span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {!isActionDisabled && (
                  <div className={feeddropdown}>
                    <Menu
                      viewScroll="close"
                      reposition="auto"
                      position="anchor"
                      menuButton={
                        <IconButton
                          style={{
                            padding: 0,
                            width: 30,
                            height: 30,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            outline: "none",
                            cursor: "pointer",
                          }}
                          onClick={(e) => e.preventDefault()}
                        >
                          {/* <img
                            src={dropdownImage}
                            alt="down-arrow-icon"
                            style={{ height: "7px", color: "#373334" }}
                          /> */}
                          <PiDotsThreeBold
                            fontSize={25}
                            color="rgba(0, 0, 0, 0.7)"
                          />
                        </IconButton>
                      }
                      transition
                      direction="bottom"
                      arrow
                      menuStyle={{
                        backgroundColor: "white",
                        borderRadius: 20,
                      }}
                      align="end"
                    >
                      {(item.Keyword_ID === "H" ||
                        item.Keyword_ID === "hashTAG" ||
                        item.message_type === "X" ||
                        item.message_type === "H" ||
                        item.Keyword_ID === "#TAG") && (
                        <MenuItem>
                          <ReusuableTagActionModal
                            type="download"
                            tagId={item?.id}
                            tagName={item?.Message}
                            tagData={item}
                            onActionSuccess={onActionSuccess}
                          />
                        </MenuItem>
                      )}
                      {(item.Keyword_ID === "H" ||
                        item.Keyword_ID === "hashTAG" ||
                        item.message_type === "X" ||
                        item.message_type === "H" ||
                        item.Keyword_ID === "#TAG") && (
                        <MenuItem>
                          <ReusuableTagActionModal
                            type="rating"
                            tagId={item?.id}
                            tagName={item?.Message}
                            tagData={item}
                            onActionSuccess={onActionSuccess}
                          />
                        </MenuItem>
                      )}
                      {(item.message_type === "A" ||
                        item.Keyword_ID === "OpenASK" ||
                        item.message_type === "H" ||
                        item.Keyword_ID === "hashTAG" ||
                        item.message_type === "X" ||
                        item.message_type === "I" ||
                        item.message_type === "S" ||
                        item.Keyword_ID === "impupdate" ||
                        item.Keyword_ID === "OpenSAY") &&
                        (item.User_ID !== userDetails?.userData?.User_ID &&
                        userDetails?.userData?.viewActivityUserTenantInfo
                          ?.isModerator === "0" ? (
                          <>
                            <MenuItem>
                              <ReusuableReportDialogmodal
                                id={item.id}
                                param={"AskorSay"}
                                onActionSuccess={onActionSuccess}
                              />
                            </MenuItem>
                            <MenuItem>
                              <ReusuableSendaMailModal
                                displayName={item?.mainuserdata?.displayName}
                                id={item.id}
                                notificationStatus={
                                  item?.mainuserdata?.notificationStatus
                                }
                                onActionSuccess={onActionSuccess}
                              />
                            </MenuItem>
                          </>
                        ) : userDetails?.userData?.viewActivityUserTenantInfo
                            ?.isModerator === "1" &&
                          item.User_ID !== userDetails?.userData?.User_ID ? (
                          <>
                            <MenuItem>
                              <ReusuableDeleteDialogmodal
                                type={item.Keyword_ID}
                                id={item.id}
                                // setDeletePost={setDeletePost}
                                // setDeletePostId={setDeletePostId}
                                deleteMessage={deleteMessage}
                              />
                            </MenuItem>
                            <MenuItem>
                              <ReusuableSendaMailModal
                                displayName={item?.mainuserdata?.displayName}
                                id={item.id}
                                notificationStatus={
                                  item?.mainuserdata?.notificationStatus
                                }
                                onActionSuccess={onActionSuccess}
                              />
                            </MenuItem>
                          </>
                        ) : (
                          <>
                            <MenuItem onClick={() => onEditSelection(item.id)}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  height: "100%",
                                  padding: "0.375rem 1.5rem",
                                  boxSizing: "border-box",
                                  cursor: "pointer",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <img
                                  src={edit}
                                  style={{
                                    width: 18,
                                    height: 18,
                                    marginRight: 8,
                                    flexShrink: 0,
                                    objectFit: "contain",
                                  }}
                                  alt="edit"
                                />
                                <span
                                  style={{ fontSize: 14, whiteSpace: "nowrap" }}
                                >
                                  Edit
                                </span>
                              </div>
                            </MenuItem>
                            <MenuItem>
                              <ReusuableDeleteDialogmodal
                                type={item.Keyword_ID}
                                id={item.id}
                                // setDeletePost={setDeletePost}
                                // setDeletePostId={setDeletePostId}
                                deleteMessage={deleteMessage}
                              />
                            </MenuItem>
                          </>
                        ))}
                    </Menu>
                  </div>
                  )}
                </div>
                <div
                  style={{
                    paddingTop: "5px",
                    fontSize: "14px",
                    fontWeight: "normal",
                    paddingBottom: "5px",
                  }}
                >
                  {editPostId === item?.id ? (
                    <PostMessageValidation
                      id={item.id}
                      Message={item.Message}
                      messageType={"feedTextArea"}
                      filtertype={filterType}
                      post={item}
                      fetchFeedData={fetchFeedData}
                      refreshFeedData={() => {
                        onCloseEdit && onCloseEdit();
                        refreshFeedData && refreshFeedData();
                      }}
                      onCloseEdit={onCloseEdit}
                      latitude={item.msgLat}
                      longitude={item.msgLng}
                      locationAddress={item.locName}
                      onDeleteAttachment={handleDeleteAttachementDoc}
                      docName={item?.docName}
                      isAttacmentDeleted={isAttacmentDeleted}
                      setIsAttacmentDeleted={setIsAttacmentDeleted}
                      feedType={"allFeed"}
                      updateFeedListPostMessage={updateFeedListPostMessage}
                    />
                  ) : (
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "baseline", // aligns with text bottom
                        flexWrap: "wrap",
                        gap: "5px", // small gap between text and file name
                      }}
                    >
                      <p className={feedMessage} id={`hide${item?.id}`}>
                        <TextWithUrlsAndHashTags
                          Message={item.Message}
                          text={item.msg}
                          urls={item.url}
                          hashtags={item.tag}
                          onHashtagClick={onHashTagClick}
                          actionDisabled={isActionDisabled}
                          tagActivityTenantId={item?.tenantID || item?.tenant}
                        />
                      </p>
                      <PostAttachmentViewer
                        docLocation={item.docLocation}
                        docTagged={item.docTagged}
                        docName={item.docName}
                        messageID={item.id}
                        className={feedstyles.myFileNameSpacingAllFeed}
                        activeTooltip={activeTooltip}
                        setActiveTooltip={setActiveTooltip}
                        onDeleteAttachment={handleDeleteAttachementDoc}
                      />
                    </div>
                  )}
                </div>
                <div className={followerandcount}>
                  {item?.message_type === "A" ||
                  item?.Keyword_ID === "OpenASK" ||
                  item?.message_type === "H" ||
                  item?.Keyword_ID === "hashTAG" ||
                  item?.Keyword_ID === "TrendingASK" ? (
                    <div>
                      <SimpleDialogDemo
                        followCount={item?.followCount}
                        followData={item?.follweduserprofile}
                        id={item?.id}
                        isActionDisabled={isActionDisabled}
                        onActionSuccess={onActionSuccess}
                      />
                    </div>
                  ) : item?.voteUp ? (
                    <div>
                      <SimpleDialogDemo
                        voteUp={item?.voteUp}
                        id={item?.id}
                        likesData={item?.likeduserprofile}
                        isActionDisabled={isActionDisabled}
                        onActionSuccess={onActionSuccess}
                      />
                    </div>
                  ) : (
                    <div>
                      <span className={followcount}>
                        {item?.voteUp === 1
                          ? `${item?.voteUp} like`
                          : `${item?.voteUp} likes`}
                      </span>
                    </div>
                  )}
                  {item?.message_type === "A" ||
                  item?.Keyword_ID === "OpenASK" ? (
                    <Tooltip title="ASK" arrow>
                      <div className={askcount}>
                        {/* {item?.followCount} */}
                      </div>
                    </Tooltip>
                  ) : item?.message_type === "S" ||
                    item?.Keyword_ID === "OpenSAY" ? (
                    <Tooltip title="SAY" arrow>
                      <div className={saycount}></div>
                    </Tooltip>
                  ) : item?.message_type === "I" ||
                    item?.Keyword_ID === "impupdate" ? (
                    <Tooltip title="UPDATE" arrow>
                      <div className={updatecount}></div>
                    </Tooltip>
                  ) : item?.message_type === "H" ||
                    item?.Keyword_ID === "hashTAG" ||
                    item?.message_type === "X" ? (
                    <Tooltip title="TAG" arrow>
                      <div className={tagcount}>
                        {/* {item?.followCount} */}
                      </div>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </div>
                <div style={{ border: "1px solid #C4C4C4" }} />
                {item?.message_type === "A" ||
                item?.message_type === "H" ||
                item?.message_type === "X" ||
                item?.Keyword_ID === "OpenASK" ||
                item?.Keyword_ID === "hashTAG" ? (
                  <div className={saysandfollow}>
                    <div className={noOfsays}>
                      <a onClick={(e) => handleSayClick(e, item?.id)}>
                        <img
                          src={
                            item.Keyword_ID === "OpenASK"
                              ? answerIcon
                              : replyIcon
                          }
                          className={
                            item.Keyword_ID === "OpenASK"
                              ? answerIconImg
                              : replyIconImg
                          }
                          alt="number of says"
                        />
                        <span>
                          {item.Keyword_ID === "OpenASK"
                            ? item.sayCount === 0
                              ? "Answer"
                              : `${item.sayCount} ${
                                  item.sayCount === 1 ? "Answer" : "Answers"
                                }`
                            : item.sayCount === 0
                              ? "Reply"
                              : `${item.sayCount} ${
                                  item.sayCount === 1 ? "Reply" : "Replies"
                                }`}
                        </span>
                      </a>
                    </div>
                    {item?.followStatus === "Active" ||
                    item?.followStatus === "Y" ? (
                      <div className={noOffollows} id={`1${item?.id}`}>
                        <a
                          className={followtext}
                          onClick={() =>
                            onFollowUnfollow(item?.id, "isFollow=0")
                          }
                          style={{
                            cursor: isActionDisabled
                              ? "not-allowed"
                              : "pointer",
                          }}
                        >
                          <img
                            src={unfollow}
                            alt="unfollow"
                            style={{ marginRight: "-2px" }}
                          />
                          <span>Unfollow</span>
                        </a>
                      </div>
                    ) : (
                      <div id={`0${item?.id}`} className={noOffollows}>
                        <a
                          className={followtext}
                          onClick={() =>
                            onFollowUnfollow(item?.id, "isFollow=1")
                          }
                          style={{
                            cursor: isActionDisabled
                              ? "not-allowed"
                              : "pointer",
                          }}
                        >
                          <img
                            src={follow}
                            alt="follow"
                            style={{ marginRight: "-2px" }}
                          />
                          <span>Follow</span>
                        </a>
                      </div>
                    )}
                    {/* {item?.hashTagType === "private" && (
                    userDetails?.userData?.moderatorStatus === "1" || userDetails.userData.isAdmin === "1"
                  ) ? (
                    <div className={priavteinvite}>
                      <img src={privateinvite} alt="Private Invite" />
                      <span
                        onClick={() => onInviteSelection(item?.TenantID || item?.tenantID, item?.id)}
                        style={{ cursor: "pointer" }}
                      >
                        Invite
                      </span>
                    </div>
                  ) : (
                    ""
                  )} */}
                  </div>
                ) : (
                  <div className={likeunlike}>
                    {item?.UserLikeStatus === "Active" ? (
                      <>
                        <a
                          id={`like${item?.id}`}
                          onClick={() =>
                            onLikeUnlikeSelection(item.id, "cacheUpdate")
                          }
                          style={{
                            cursor: isActionDisabled
                              ? "not-allowed"
                              : "pointer",
                          }}
                        >
                          <img src={like} alt="like" />
                          Like
                        </a>
                      </>
                    ) : (
                      <a>
                        <img src={unlike} alt="unlike" />
                        Like
                      </a>
                    )}
                  </div>
                )}

                {item?.id === id && (
                  <div style={{ paddingTop: "10px" }}>
                    <PostMessageValidation
                      id={item?.id}
                      type={"childSay"}
                      userImageSrc={`${imageServerURL}${userDetails?.userData?.uimage}`}
                      readOnly={isActionDisabled}
                      postChildSayData={postChildSayData}
                      fetchChildSaysData={fetchChildSaysData}
                      refreshFeedData={refreshFeedData}
                      flow={flow}
                      keywordName={item?.Keyword_ID}
                    />
                    <ChildSay
                      id={item.id}
                      key={item.id}
                      loading={childSayLoading}
                      childSaysData={childSaysData || {}}
                      fetchVoteUpStatus={fetchVoteUpStatus}
                      fetchFeedData={fetchFeedData}
                      deleteMessage={deleteMessage}
                      refreshFeedData={refreshFeedData}
                      isActionDisabled={isActionDisabled}
                      flow={flow}
                      onActionSuccess={onActionSuccess}
                      onHashTagClick={onHashTagClick}
                    />
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <>
            {feedLoading || isMoreLoading ? (
              <div className={poststyles.loaderContainer}>
                <CircularProgress
                  // size={25}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "100px",
                  }}
                />
              </div>
            ) : (
              <div className={nodata}>
                <img src={NoDataFound} alt="NoDataFound" width={"30%"} />
                <p>{showMsg(filterType)}</p>
              </div>
            )}
          </>
        )}
      </div>
      <div ref={loader} />
      <MapDialog
        open={openMap}
        onClose={handleCloseMap}
        clickedLocation={clickedLocation}
        zoomLevel={12}
      />
      {showUnfollowAlert && (
        <ConfirmationDialog
          open={true}
          handleClose={() => setShowUnfollowAlert(null)}
          type={"warning"}
          title={"Are you sure you want to Unfollow?"}
          acceptLabel={"Yes"}
          onAccept={() => {
            followunfollowCallback(
              showUnfollowAlert?.id,
              showUnfollowAlert?.followstatus,
            );
            setShowUnfollowAlert(null);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default Feed;
